import Steps from './src/steps';

Steps.install = function(Vue) {
  Vue.component(Steps.name, Steps);
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/steps/index.js